import React from 'react';
import { useMutation } from '@apollo/client';
import { Typography } from '@mui/material';

import { DELETE_QR_CODE_MUTATION } from 'globals/graphql';
import { DeleteQRCodeConfirmationDialogProps } from '../types';
import MoovsDialog from 'components/MoovsDialog';
import { useAnalytics } from 'globals/hooks';

function DeleteQRCodeConfirmationDialog(props: DeleteQRCodeConfirmationDialogProps) {
  const { open, onClose, qrCode, onSuccess, onError } = props;

  // hooks
  const { track } = useAnalytics();

  // mutations
  const [deleteQRCode, { loading }] = useMutation(DELETE_QR_CODE_MUTATION, {
    onCompleted: (data) => {
      if (data.deleteQrCode.result.__typename === 'QRCode') {
        onSuccess();
        onClose();
        track('qrCodeApp_deleted');
      } else if (data.deleteQrCode.result.__typename === 'DeleteQrCodeFailure') {
        onError(data.deleteQrCode.result.message);
      }
    },
    onError: (error) => {
      onError(error);
    },
  });

  // event handlers
  const handleDelete = () => {
    deleteQRCode({
      variables: {
        input: {
          qrCodeId: qrCode.qrCodeId,
        },
      },
    });
  };

  return (
    <MoovsDialog
      dialogTitle="Are you sure you want to delete this QR code?"
      closeButtonText="No, keep"
      acceptButtonText="Yes, delete"
      acceptButtonIsDelete
      open={open}
      onClose={onClose}
      onAccept={handleDelete}
      acceptDisabled={loading}
      size="xs"
      hideTopBorder
      sx={{ pt: 1 }}
    >
      <Typography variant="body1" sx={{ mb: 2 }}>
        This will only remove it from your list. The code will continue to work for anyone who already has access to it.
      </Typography>
    </MoovsDialog>
  );
};

export default DeleteQRCodeConfirmationDialog;